/**
 * @Description 抽屉
 */
import { FC, MutableRefObject, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Detail from '.';

const ShopDetailDrawer:FC<any> = forwardRef(({ reload }, ref) => {
  useImperativeHandle(ref, () => ({
    init
  }));

  const [id, setId] = useState(null);
  const [tab, setTab] = useState(''); // 如果弹出框详情内有 tab，则可以设置 tab
  const [open, setOpen] = useState(false); // 弹出框是否打开
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();

  const init = (id, tab) => {
    setId(id);
    tab && setTab(tab);
    setOpen(true);

    setTimeout(() => {
      drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
      detail.current.init instanceof Function && detail.current.init();
    }, 0);
  };

  const [container, setContainer] = useState<HTMLElement | null>(null);
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const target = drawerWrapper.current?.getBodyElement();
        target && setContainer(target);
      }, 0);
    }
  }, [open]);

  return (
    <V2Drawer
      onRef={drawerWrapper}
      open={open}
      onClose={() => setOpen(false)}
      maskClosable={false}
      push={false}>
      {open && <Detail
        reload={reload}
        ref={detail}
        container={container}
        tab={tab}
        id={id as any}
        onClose={() => setOpen(false)}/>}
    </V2Drawer>
  );
});

export default ShopDetailDrawer;
